import React from 'react'
import styled from 'styled-components'
import colors from '~/styles/colors'
import { radius } from '~/styles/vars'

export interface Props {
    handleSubmit: (e: any) => void
    handleClick: (e: any) => void
}

const TaskForm: React.FC<Props> = ({ handleSubmit, handleClick }) => {
    return (
        <>
            <Background onClick={handleClick} />
            <Modal onSubmit={handleSubmit}>
                <h2>Ajouter une tâche</h2>
                <div>
                    <LabelInput
                        type="text"
                        autoFocus
                        placeholder="Acheter du pain"
                        name="label"
                        required
                        autoComplete="off"
                    ></LabelInput>
                    <Submit type="submit" value="Ajouter" />
                </div>
                <div />
            </Modal>
        </>
    )
}

const Submit = styled.input`
    width: 15rem;
    border-radius: ${radius.xs};
    margin: 0 auto;
    background: none;
    outline: none;
    border: 0.2rem solid ${colors.accent[500]};
    padding: 1rem 2rem;
    color: white;
    font-size: 2rem;
    display: block;
    transition: 0.1s ease-in-out;
    :hover {
        color: ${colors.main[500]};
        transition: 0.1s ease-in-out;
        background: ${colors.accent[500]};
    }
`

const LabelInput = styled.input`
    font-size: 3rem;
    text-align: center;
    margin: 3rem;
    color: white;
    width: 80%;
    background: none;
    outline: none;
    box-shadow: none;
    border: none;
    border-bottom: 3px solid ${colors.accent[500]};
`

const Modal = styled.form`
    border-radius: 1rem;
    padding: 2rem 3rem;
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    right: 0;
    bottom: 50%;
`

const Background = styled.div`
    opacity: 0.98;
    position: absolute;
    display: block;
    height: 100vh;
    margin-left: auto;
    margin-right: auto;
    background-color: ${colors.main[700]};
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
`

export default TaskForm
